import React from 'react';

import LoadingSpinner from '../../../../components/LoadingSpinner';

const ConversationLoading: React.FC = () => {
  return (
    <div className='flex flex-col h-full bg-gray-50'>
      <div className='flex-1 flex items-center justify-center'>
        <div className='text-center'>
          <div className='text-lg font-medium text-gray-600 mb-2'>
            Loading conversations...
          </div>
          <LoadingSpinner size='lg' className='mx-auto' />
        </div>
      </div>
    </div>
  );
};

export default ConversationLoading;